import dynamic from 'next/dynamic';

const Video = dynamic(() => import("./CoreVideo"), {
  ssr: false,
})

export default Video